import { createReducer, on } from '@ngrx/store';
import {
  changeEmail,
  changeEmailFailure,
  changeEmailSuccess,
  changePassword,
  changePasswordFailure,
  changePasswordSuccess,
  loadUserProfileFailure,
  loadUserProfileSuccess,
  loginFailure,
  loginSuccess,
  logoutSuccess,
  registerFailure,
  resetPassword,
  resetPasswordFailure,
  resetPasswordReset,
  resetPasswordSuccess,
  updateUserProfileFailure,
  updateUserProfileSuccess,
} from './user.actions';
import { initialState, LoadingState } from './user.state';

export const userReducer = createReducer(
  initialState,
  // Auth actions
  on(loginSuccess, (state, { authInfo }) => ({
    ...state,
    authInfo,
    authInitialized: true,
    loading: false,
    error: null,
  })),
  on(loginFailure, (state, { error }) => ({
    ...state,
    authInfo: null,
    loading: false,
    error,
  })),
  on(registerFailure, (state, { error }) => ({
    ...state,
    authInfo: null,
    loading: false,
    error,
  })),
  on(logoutSuccess, (state) => ({
    ...initialState,
    authInitialized: true,
  })),

  // Profile actions
  on(loadUserProfileSuccess, (state, { userProfile }) => ({
    ...state,
    profile: userProfile,
    loading: false,
    error: null,
  })),
  on(loadUserProfileFailure, (state, { error }) => ({
    ...state,
    profile: null,
    loading: false,
    error,
  })),
  on(updateUserProfileSuccess, (state, { userProfile }) => ({
    ...state,
    profile: userProfile,
    previousProfile: state.profile,
    loading: false,
    error: null,
  })),
  on(updateUserProfileFailure, (state, { error }) => ({
    ...state,
    profile: null,
    loading: false,
    error,
  })),

  // Reset Password actions
  on(resetPassword, (state) => ({
    ...state,
    resetPassword: {
      ...state.resetPassword,
      status: 'pending' as LoadingState,
      error: null,
    },
  })),
  on(resetPasswordSuccess, (state, { email }) => ({
    ...state,
    resetPassword: {
      status: 'success' as LoadingState,
      error: null,
      lastEmailAttempt: email,
    },
  })),
  on(resetPasswordFailure, (state, { error }) => ({
    ...state,
    resetPassword: {
      ...state.resetPassword,
      status: 'error' as LoadingState,
      error,
    },
  })),
  on(resetPasswordReset, (state) => ({
    ...state,
    resetPassword: {
      status: 'idle' as LoadingState,
      error: null,
      lastEmailAttempt: null,
    },
  })),

  // Change Password actions
  on(changePassword, (state) => ({
    ...state,
    changePassword: {
      status: 'pending' as LoadingState,
      error: null,
    },
  })),
  on(changePasswordSuccess, (state) => ({
    ...state,
    changePassword: {
      status: 'success' as LoadingState,
      error: null,
    },
  })),
  on(changePasswordFailure, (state, { error }) => ({
    ...state,
    changePassword: {
      status: 'error' as LoadingState,
      error,
    },
  })),

  // Change Email actions
  on(changeEmail, (state) => ({
    ...state,
    changeEmail: {
      status: 'pending' as LoadingState,
      error: null,
    },
  })),
  on(changeEmailSuccess, (state) => ({
    ...state,
    changeEmail: {
      status: 'success' as LoadingState,
      error: null,
    },
  })),
  on(changeEmailFailure, (state, { error }) => ({
    ...state,
    changeEmail: {
      status: 'error' as LoadingState,
      error,
    },
  }))
);
